import { Component } from 'preact';
let flamegraph;
let d3;
let tip;

import 'd3-flame-graph/src/flamegraph.css';

export class FlameGraph extends Component {
	state = {
		d3Select: null,
		tooltip: null,
		graph: null
	}

	chartRef = null

	setStateAsync (state) {
		return new Promise(resolve => {
			this.setState(state, resolve);
		});
	}

	async componentDidUpdate () {
		if (typeof window === 'undefined') return;

		await importModules();

		if (!this.state.tooltip || !this.state.graph) {
			const tooltip = tip()
				.attr('class', 'd3-flame-graph-tip')
				.html(({ data }) => createTipMarkup(data));

			await this.setStateAsync({
				d3Select: d3.select('#chart'),
				tooltip,
				graph: flamegraph()
					.width(this.chartRef.clientWidth)
					.tooltip(tooltip)
			});
		}

		if (this.state.d3Select && this.props.data.children) {
			this.state.graph.height(0);
			const rootColour = '#ff6e00'
			this.state.d3Select
				.datum(this.props.data)
				.call(this.state.graph.setColorMapper(node => node.data.filename ? node.data.color : rootColour));
		}
	}

	render () {
		return (<div class="column">
			<div
				class="chart"
				id="chart"
				ref={ref => this.chartRef = ref}
			/>
		</div>);
	}
}

async function importModules () {
	if (!flamegraph || !d3 || !tip) {
		const imports = await Promise.all([
			import('d3'),
			import('d3-tip'),
			import('d3-flame-graph')
		]);

		d3 = imports[0];
		tip = imports[1].default;
		flamegraph = imports[2].flamegraph;
	}
}

// Some non react markup building to be passed into D3's tooltip module.
function createTipMarkup (data) {
	let markup = ''
	if (data.name) {
		markup += data.name
	} else {
		markup += 'root'
	}

	if (data.lineNumber) {
		markup += `:${data.lineNumber}`
	}

	markup += `<br />Time: ${(data.value / 1000000).toFixed(2)}ms`

	if (data.filename) {
		markup += `<br />File: ${data.filename}`
	}

	return markup
}



// WEBPACK FOOTER //
// ./components/flamegraph.js